import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  infoBox: {
    backgroundColor: theme.palette.lightPastelBlue,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  button: {
    height: 48,
    fontWeight: 600,
    letterSpacing: '0.04em',
    borderRadius: 8,
    textTransform: 'uppercase',
  },
  daiButton: {
    color: theme.palette.primary.newAuth,
    borderColor: theme.palette.primary.newAuth,
    '&:hover': {
      borderColor: theme.palette.primary.hover,
      backgroundColor: theme.palette.primary.light,
    },
  },
  daiIcon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
  },
  manualButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
}))

export default useStyles
